import { render } from "./WaterCheck.vue?vue&type=template&id=5a37117a&scoped=true&ts=true"
import script from "./WaterCheck.vue?vue&type=script&lang=ts"
export * from "./WaterCheck.vue?vue&type=script&lang=ts"

import "./WaterCheck.vue?vue&type=style&index=0&id=5a37117a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a37117a"]])

export default __exports__